import { z } from 'zod';

import { type BaseItem } from '../common.js';

export enum VoicePersonaProvider {
  ElevenLabs = 'ElevenLabs',
  OpenAi = 'OpenAi',
  Cartesia = 'Cartesia',
}

export enum LlmModelCompatibility {
  RealtimeVoiceOnly = 'RealtimeVoiceOnly',
  All = 'All',
  TextBasedOnly = 'TextBasedOnly',
}

export const BaseVoicePersonaSchema = z.object({
  provider: z.enum(VoicePersonaProvider),
  personaId: z.string(),
  displayName: z.string(),
  llmModelCompatibility: z.enum(LlmModelCompatibility),
});

type BaseVoicePersona = z.infer<typeof BaseVoicePersonaSchema>;
export type VoicePersona = BaseItem & BaseVoicePersona;

export const FindAllOptionsSchema = z.object({
  provider: z.enum(VoicePersonaProvider).optional(),
  llmModelCompatibilities: z.array(z.enum(LlmModelCompatibility)).optional(),
});
export type FindAllOptions = z.infer<typeof FindAllOptionsSchema>;
